//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  props: ["index"],
  data() {
    return {
      swiperOption: {
        observer: true,
        observeParents: true,
        slidesPerView: 1,
        spaceBetween: 30,
        loop: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        on: {
          slideChange: function() {
            for (var i = 0; i < this.bannerList.length; i++) {
              this.$refs["videoPlayer" + i][0].pause();
            }
          }.bind(this),
          slidePrevTransitionEnd: () => {
            this.autoPlayVideo();
          },
          slideNextTransitionEnd: () => {
            this.autoPlayVideo();
          }
        }
      },
      bannerListPc: [
        {
          videoSource: require("@/assets/static/gameVideo/baijiale_pc_game.mp4"),
          name: "baijiale"
        },
        {
          videoSource: require("@/assets/static/gameVideo/luopan_pc_game.mp4"),
          name: "lunpan"
        },
        {
          videoSource: require("@/assets/static/gameVideo/buyu_pc_game.mp4"),
          name: "buyu"
        },
        {
          videoSource: require("@/assets/static/gameVideo/zhajinhua_pc_game.mp4"),
          name: "zhajinhua"
        },
        {
          videoSource: require("@/assets/static/gameVideo/niuniu_pc_game.mp4"),
          name: "niuniu"
        }
      ],
      bannerListMobli: [
        {
          videoSource: require("@/assets/static/gameVideo/baijiale_m_game.mp4"),
          name: "baijiale"
        },
        {
          videoSource: require("@/assets/static/gameVideo/luopan_m_game.mp4"),
          name: "lunpan"
        },
        {
          videoSource: require("@/assets/static/gameVideo/buyu_m_game.mp4"),
          name: "buyu"
        },
        {
          videoSource: require("@/assets/static/gameVideo/zhajinhua_m_game.mp4"),
          name: "zhajinhua"
        },
        {
          videoSource: require("@/assets/static/gameVideo/niuniu_m_game.mp4"),
          name: "niuniu"
        }
      ],
      bannerList: [
        {
          videoSource: require("@/assets/static/gameVideo/baijiale_pc_game.mp4"),
          name: "baijiale"
        },
        {
          videoSource: require("@/assets/static/gameVideo/luopan_pc_game.mp4"),
          name: "lunpan"
        },
        {
          videoSource: require("@/assets/static/gameVideo/buyu_pc_game.mp4"),
          name: "buyu"
        },
        {
          videoSource: require("@/assets/static/gameVideo/zhajinhua_pc_game.mp4"),
          name: "zhajinhua"
        },
        {
          videoSource: require("@/assets/static/gameVideo/niuniu_pc_game.mp4"),
          name: "niuniu"
        }
      ]
    };
  },
  components: {
    swiper,
    swiperSlide
  },
  methods: {
    autoPlayVideo() {
      let videoIndex = null;
      if (this.$refs.videoSwiper.swiper) {
        videoIndex = this.$refs.videoSwiper.swiper.realIndex;
      }
      if (videoIndex != null) {
        this.$nextTick(() => {
          if (this.$refs["videoPlayer" + videoIndex].length > 0) {
            this.$refs["videoPlayer" + videoIndex][0].play();
          }
        });
      }
    },
    toggleVideo() {
      if (window.innerWidth > 700) {
        this.bannerList = this.bannerListPc;
      } else {
        this.bannerList = this.bannerListMobli;
      }
    }
  },
  mounted() {
    this.toggleVideo();
    this.$refs.videoSwiper.swiper.slideTo(this.index);
    this.$nextTick(() => {
      if (this.$refs["videoPlayer" + this.index].length > 0) {
        this.$refs["videoPlayer" + this.index][0].play();
      }
    });
    window.onresize = () => {
      this.toggleVideo();
    };
  }
};



// WEBPACK FOOTER //
// ./src/components/FullScreenRotation/index.vue